/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const AngleDownSmall: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M5.70711 6.29289C5.31658 5.90237 4.68342 5.90237 4.29289 6.29289C3.90237 6.68342 3.90237 7.31658 4.29289 7.70711L7.29289 10.7071C7.68342 11.0976 8.31658 11.0976 8.70711 10.7071L11.7071 7.70711C12.0976 7.31658 12.0976 6.68342 11.7071 6.29289C11.3166 5.90237 10.6834 5.90237 10.2929 6.29289L8 8.58579L5.70711 6.29289Z' />
		</Svg>
	);
};

export { AngleDownSmall };
